import 'jquery.toc/jquery.toc.js'

$(document).ready(function () {
    // scroll to top *jquery for smoother scroll animation
    $('.sp-jump-sec__list a').on('click', function (e) {
        e.preventDefault();
        let target = this.getAttribute('href');
        if (target) {
            let $targetElement = $(target.replace(/[\\^$*+?.()|[\]{}&\/,:®'!]/g, '\\$&'));
            if ($targetElement.length) {
                $('html, body').animate({
                    scrollTop: $targetElement.offset().top - 200
                }, 2000);
                $('.js-jl-trigger-accordion').click();
            }
        }
    });
});
